import React from 'react';
import {QRCodeSVG }from 'qrcode.react';
import { Box } from '@mui/material';

function QRCodeDisplay({ value }) {
  return (
    <Box sx={{ textAlign: 'center', margin: '1rem' }}>
      <QRCodeSVG value={value} size={256} />
    </Box>
  );
}

export default QRCodeDisplay;